var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"to-dashboard-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(" Back to dashboard ")])}
var staticRenderFns = []

export { render, staticRenderFns }